import type { Ordering } from "@prismicio/client"

import { validateAPIPath } from "../RequestAPIPathFieldset"
import { allowedOrderingPaths } from "./constants"

export function queryOrderingsToOrderings(rawOrderings: string[]): Ordering[] {
  const parsedOrderings: Ordering[] = []

  for (const rawOrdering of rawOrderings) {
    const entries = decodeURIComponent(rawOrdering)
      // Remove leading `[` and trailing `]`
      .replace(/(^\[)|(\]$)/g, "")
      // Split on each entry `,`
      .split(",")
      // Trim each entry
      .map((entry) => entry.trim())

    for (const entry of entries) {
      // Entries are of the form `field` or `path direction`
      const [field, direction] = entry.split(/\s+/)

      try {
        validateAPIPath(field, {
          allowedPaths: allowedOrderingPaths,
          context: "ordering",
        })
      } catch (error) {
        console.warn(
          `Could not parse ordering: ${rawOrdering}, invalid path`,
          error,
        )
        continue
      }

      if (direction && !["asc", "desc"].includes(direction)) {
        console.warn(`Invalid ordering direction: ${direction}`)
        continue
      }

      parsedOrderings.push({
        field,
        direction: direction as "asc" | "desc" | undefined,
      })
    }
  }

  return parsedOrderings
}
